"use client";
import React, { useEffect, useRef } from "react";
import Icon from "@/components/ui/AppIcon";

const gruende = [
  {
    icon: "WrenchScrewdriverIcon",
    title: "Sauberer und sorgfältiger PC-Zusammenbau",
    desc: "Jede Komponente wird mit Präzision montiert – kein Kabel liegt falsch, keine Schraube sitzt locker.",
  },
  {
    icon: "TrophyIcon",
    title: "5+ Jahre PC-Erfahrung",
    desc: "Erfahrung mit Gaming- und High-End PCs – von Budget-Builds bis zu High-End-Systemen mit Custom-Kühlung.",
  },
  {
    icon: "UserIcon",
    title: "Persönlicher Kontakt statt anonymem Shop",
    desc: "Du sprichst direkt mit mir – kein Call-Center, kein Ticket-System. Ehrlich, direkt und persönlich.",
  },
  {
    icon: "CurrencyDollarIcon",
    title: "Transparente Preise ohne versteckte Kosten",
    desc: "Was du siehst, ist was du zahlst. Keine Überraschungen, keine versteckten Gebühren.",
  },
  {
    icon: "ShieldCheckIcon",
    title: "Jeder PC wird vor Übergabe getestet",
    desc: "Ausführliche Tests nach dem Zusammenbau – Stabilität, Performance und alle Komponenten werden geprüft.",
  },
];

export default function WarumSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("revealed");
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -60px 0px" }
    );
    sectionRef.current?.querySelectorAll(".reveal-hidden").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="warum" ref={sectionRef} className="relative py-28 lg:py-36 px-6 lg:px-12 bg-[#0A0A14] overflow-hidden">
      <div className="orb w-[500px] h-[500px] bg-blue-500/6 top-0 right-0" />
      <div className="orb w-[300px] h-[300px] bg-violet-500/5 bottom-0 left-0" />

      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16 reveal-hidden">
          <div className="section-label justify-center mb-4">Vertrauen</div>
          <h2 className="font-display font-extrabold text-[clamp(2rem,4vw,3.2rem)] text-white leading-tight">
            Warum{" "}
            <span className="gradient-text">mein Service?</span>
          </h2>
        </div>

        {/* Trust Points */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {gruende.map((g, i) => (
            <div
              key={g.title}
              className={`service-card reveal-hidden group ${
                i === 4 ? "sm:col-span-2 lg:col-span-1" : ""
              }`}
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="relative inline-flex mb-5">
                <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-violet-500/20 to-blue-500/10 border border-violet-500/20 flex items-center justify-center group-hover:border-violet-500/50 transition-colors">
                  <Icon name={g.icon as any} size={22} className="text-violet-400" />
                </div>
              </div>
              <h3 className="font-display font-bold text-base text-white mb-2 leading-snug">{g.title}</h3>
              <p className="text-sm text-white/45 leading-relaxed">{g.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
